import { convertToSelectedUnit } from '../../../../utils/unitConverter'
import NoteExists from '@modul-connect/shared/img/checkmark.svg'
import React from 'react'
import { groupingOptions } from '../drivingLogPage'
import { useTranslation } from 'react-i18next'

const minWidthDriverCol = 250
const minWidthVehicleCol = 220
const routesWidth = 130
const noteWidth = 130

export const getLogSummaryColumns = (t) => {
  const driverColumn = [{
    id: 'name',
    label: t('drivingJournal.driver'),
    minWidth: minWidthDriverCol,
    hide: [],
    align: 'left'
  }]

  const vehicleColumn = [{
    id: 'name',
    label: t('drivingJournal.vehicle'),
    minWidth: minWidthVehicleCol,
    hide: [],
    align: 'left'
  }]

  const commonColumns = [
    {
      id: 'numberOfRoutes',
      label: t('drivingJournal.routes'),
      width: routesWidth,
      hide: []
    },
    {
      id: 'businessKilometers',
      format: (value) =>
        (value || value === 0) ? convertToSelectedUnit(value, 1, 'distance') : '-',
      label: t('drivingJournal.business'),
      hide: []
    },
    {
      id: 'privateKilometers',
      format: (value) =>
        (value || value === 0) ? convertToSelectedUnit(value, 1, 'distance') : '-',
      label: t('drivingJournal.private'),
      hide: []
    },
    {
      id: 'businessRoutesWithoutNotes',
      label: t('drivingJournal.note'),
      width: noteWidth,
      warning: (value) => value > 0,
      icon: <img style={{ width: 30 }} src={NoteExists} />,
      showIcon: (value) => value === 0,
      hide: [],
      align: 'left'
    }
  ]

  return {
    driver: driverColumn.concat(commonColumns),
    vehicle: vehicleColumn.concat(commonColumns)
  }
}
const routeNrWidth = 70
const startEndTimeWidth = 40

const log_columns = [
  {
    id: 'routeNumber',
    isCustomComponent: true,
    width: routeNrWidth,
    //isSortable: true
  },
  {
    id: 'startEndTime',
    hasValues: true,
    width: startEndTimeWidth,
    noPadding: true
  },
  {
    id: 'startEndAddress',
    hasValues: true,
    minWidth: minWidthDriverCol + routesWidth - (startEndTimeWidth + routeNrWidth)
  },
  {
    id: 'weight',
    hasValues: true,
    icon: true,
    iconWidth: 16,
    minWidth: 150,
  },
  {
    id: 'purpose',
    hasValues: true,
    icon: true,
    iconWidth: 24,
    minWidth: 170,
    //    isSortable: true
  },
  {
    id: 'distance',
    hasValues: true,
    // isSortable: true,
    minWidth: 120,
  },
  {
    id: 'hasNote',
    hasValues: true,
    icon: true,
    iconWidth: 24,
    minWidth: 140,
    //   isSortable: true
  },
  {
    id: 'driver',
    hasValues: true,
    minWidth: 150,
  },
  {
    id: 'totalMileage',
    hasValues: true,
    icon: true,
    iconWidth: 24,
    minWidth: 175,
  },
  {
    id: 'expand'
  }
]

export const getDrivingLogsColumns = (groupBy, showStartWeight) => {
  const columns = groupBy === groupingOptions.byDriver ? log_columns : log_columns.map(col => (col.id === 'driver') ? { id: 'vehicle', hasValues: true, minWidth: 150 } : col)
  if (!showStartWeight) return columns.filter(col => col.id !== 'weight')
  else return columns
}